/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

function isTransgender(genderKey) {
  switch (genderKey) {
    case 'list.gender.transgender-female':
    case 'list.gender.transgender-male':
    case 'list.gender.other':
      return true;
    default:
      return false;
  }
}

function isOther(genderKey) {
  return genderKey === 'list.gender.other';
}

class Gender {

  static createFromId(genderList, id) {
    const data = genderList.filter((g) => (g.id === id))[0] || {};

    return new Gender(data);
  }

  static isOther(genderData) {
    return isOther(genderData.key);
  }

  static isTransgender(genderData) {
    return isTransgender(genderData.key);
  }

  constructor(genderData = {}) {
    this.data = genderData;
  }

  isTransgender() {
    return isTransgender(this.data.key);
  }

  isOther() {
    return isOther(this.data.key);
  }

  hasDefaultBirthSex() {
    return _.isNumber(this.data.default_birth_sex_id);
  }

  messageKey() {
    return this.data.key ? `${this.data.key}.name` : '';
  }

  getDefaultBirthSex() {
    return _.get(this, 'data.default_birth_sex_id', '');
  }
}

export default Gender;
